export default [
  {
    // 100k -> 200k -> 300k -> Unsold, no price -> Status sold
    title: 'Price, Low to High',
    field: home => {
      if (home.status && home.status !== 'Sold') {
        return (1 / home.price) || 0;
      }
      return -1;
    },
    dir: 'desc',
  },
  {
    // 300k -> 200k -> 100k -> Unsold, no price -> Status sold
    title: 'Price, High to Low',
    field: home => {
      if (home.status && home.status !== 'Sold') {
        return home.price || 0;
      }
      return -1;
    },
    dir: 'desc',
  },
  { title: 'Beds, Low to High', field: 'beds' },
  { title: 'Beds, High to Low', field: 'beds', dir: 'desc' },
  { title: 'Address, A to Z', field: 'address.streetAddress' },
  { title: 'Address, Z to A', field: 'address.streetAddress', dir: 'desc' },
];



// WEBPACK FOOTER //
// ./src/components/SortOptions/homes.js